import React, { Component } from "react";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import * as appConst from "../../Common/constants";
import { isNull } from "util";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import DatePicker from "react-datepicker";

var style = {
  height: 80
};
class Outbound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spinnerClass: "collapse",
      dataClass: "",
      nameSuggestions: null,
      nameList: [],
      medList: [],
      stock: 0,
      qty: 0,
      mno: "",
      name: "",
      mainStock: 0,
      subStock: 0,
      a_kit: 0,
      b_kit: 0,
      source: "",
      patientNameSuggestions: null,
      patientNameList: [],
      patient: "",
      toClass: "collapse",
      patientClass: "collapse",
      transferTo: "",
      txnDate: new Date()
    };

    this.handleTxnDateChange = this.handleTxnDateChange.bind(this);
  }

  componentDidMount() {
    this.LoadNames();
    this.LoadPatients();
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/medicine/getNames"
      )
      .then(response => {
        this.setState({ medList: response.data });
        let nameData = response.data;
        nameData.forEach(function (item) {
          _nameList.push(item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  LoadPatients() {
    let _patientNameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/patient/getNames"
      )
      .then(response => {
        let nameData = response.data;
        nameData.forEach(function (item) {
          _patientNameList.push("[" + item.pno + "] " + item.name);
        });
        this.setState({ patientNameList: _patientNameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestPatientName(event) {
    let results = this.state.patientNameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ patientNameSuggestions: results });
  }

  render() {
    const transferSourceList = [
      { label: "Main Stock : " + this.state.mainStock, value: "Main" },
      { label: "Sub Stock : " + this.state.subStock, value: "Sub" },
      { label: "A Kit : " + this.state.a_kit, value: "A Kit" },
      { label: "B Kit : " + this.state.b_kit, value: "B Kit" }
    ];

    const TRANSFER_TO_LIST = [
      { label: "A Kit", value: "A Kit" },
      { label: "B Kit", value: "B Kit" },
      { label: "OP", value: "OP" }
    ];

    return (
      <div>
        <div>
          <h5 align="center">Medicine Outbound</h5>
        </div>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-2">Medicine</div>
            <div className="col col-md-8">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Date</div>
            <div className="col col-md-8">
              <DatePicker
                selected={this.state.txnDate}
                onChange={this.handleTxnDateChange}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 24)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Transfer From</div>
            <div className="col col-md-8">
              <SelectButton
                value={this.state.source}
                options={transferSourceList}
                onChange={this.onSourceChange}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Quantity</div>
            <div className="col col-md-4">
              <InputText
                type="text"
                keyfilter="pint"
                value={this.state.qty}
                onChange={e => this.setState({ qty: e.target.value })}
                style={{ width: "300px" }}
                className="p-error"
              />
            </div>
          </div>
          <div className={this.state.toClass}>
            <div className="col col-md-2">Transfer To</div>
            <div className="col col-md-4">
              <SelectButton
                value={this.state.transferTo}
                options={TRANSFER_TO_LIST}
                onChange={this.onDestChange}
                className="p-error"
              />
            </div>
          </div>
          <div className={this.state.patientClass}>
            <div className="col col-md-2">Patient</div>
            <div className="col col-md-4">
              <AutoComplete
                value={this.state.patient}
                onChange={this.onPatientNameChange}
                suggestions={this.state.patientNameSuggestions}
                completeMethod={this.suggestPatientName.bind(this)}
                size={38}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <button
              onClick={this.onTransferClick}
              className="btn btn-primary btn-md mr-2"
            >
              Transfer
            </button>

          </div>
          <Growl ref={el => (this.growl = el)} />
          <Messages ref={el => (this.messages = el)} />
        </div>
      </div>
    );
  }

  handleTxnDateChange(date) {
    this.setState({ txnDate: date });
  }

  onSourceChange = e => {
    this.setState({ source: e.value });
    if (e.value === "Sub")
      this.setState({ toClass: "row p-1 border", patientClass: "collapse" });
    else if (e.value === "A Kit" || e.value === "B Kit")
      this.setState({ patientClass: "row p-1 border", toClass: "collapse" });
    else
      this.setState({
        toClass: "collapse",
        patientClass: "collapse",
        patient: "",
        transferTo: ""
      });
  };

  onDestChange = e => {
    this.setState({ transferTo: e.value });
    if (e.value === "OP") this.setState({ patientClass: "row p-1 border" });
    else this.setState({ patientClass: "collapse", patient: "" });
  };

  onPatientNameChange = e => {
    this.setState({ patient: e.value });
  };

  onNameSelect = e => {
    let results = this.state.medList.filter(t => {
      return t.name.toLowerCase() === e.value.toLowerCase();
    })[0];

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/medicine/getStock/" +
        results.mno
      )
      .then(response => {
        this.setState({
          mainStock: response.data.stock.main,
          subStock: isNull(response.data.stock.sub)
            ? 0
            : response.data.stock.sub,
          a_kit: isNull(response.data.stock.a_kit)
            ? 0
            : response.data.stock.a_kit,
          b_kit: isNull(response.data.stock.b_kit)
            ? 0
            : response.data.stock.b_kit
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    this.setState({ mno: results.mno, name: results.name });
  };

  onNameChange = e => {
    this.setState({
      name: e.value,
      mainStock: 0,
      subStock: 0,
      a_kit: 0,
      b_kit: 0,
      qty: 0,
      transferTo: "",
      patient: ""
    });
  };

  onTransferClick = async e => {
    e.preventDefault();
    //console.log(this.state.source);
    if (this.state.source !== "" && this.state.source !== null) {
      if (this.state.source === "Main") {
        if (this.state.qty <= this.state.mainStock && this.state.qty > 0) {
          const obj = {
            mno: this.state.mno,
            qty: this.state.qty,
            name: this.state.name,
            source: "Transfer",
            stocktype: "Main Stock",
            transferto: "Sub Stock",
            txnDate: this.state.txnDate
          };

          axios
            .post(
              (process.env.NODE_ENV !== "development"
                ? appConst.API_URL_PROD
                : appConst.API_URL_DEV) +
              "/medicine/transfer",
              obj
            )
            .then(res => {
              this.ClearData();
              this.growl.show({
                severity: "success",
                summary: "Success",
                detail: "Medicine Transferred !!!"
              });
              this.LoadNames();
            })
            .catch(error => {
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong !!"
              });
            });
        } else {
          this.messages.show({
            severity: "error",
            summary: "Error !!",
            detail: "Invalid Quantity !!"
          });
        }
      } else if (this.state.source === "Sub") {
        if (
          this.state.qty <= this.state.subStock &&
          this.state.qty > 0 &&
          this.state.transferTo !== null &&
          this.state.transferTo !== ""
        ) {
          const obj = {
            mno: this.state.mno,
            qty: this.state.qty,
            name: this.state.name,
            source: "Transfer",
            stocktype: "Sub Stock",
            transferto: this.state.transferTo,
            txnDate: this.state.txnDate
          };

          if (this.state.transferTo === "OP" && this.state.patient == "") {
            this.messages.show({
              severity: "error",
              summary: "Error !!",
              detail: "Select Patient !!"
            });
          } else {
            let apiTransfer = "";
            if (this.state.transferTo === "OP") {
              apiTransfer = "OP";
              obj.medicinename = this.state.name;
              obj.patient = this.state.patient;
            }

            axios
              .post(
                (process.env.NODE_ENV !== "development"
                  ? appConst.API_URL_PROD
                  : appConst.API_URL_DEV) +

                "/medicine/transfer" +
                apiTransfer,
                obj
              )
              .then(res => {
                this.ClearData();

                this.setState({
                  toClass: "collapse",
                  patientClass: "collapse"
                });

                this.growl.show({
                  severity: "success",
                  summary: "Success",
                  detail: "Medicine Transferred !!!"
                });
                this.LoadNames();
              })
              .catch(error => {
                this.growl.show({
                  severity: "error",
                  summary: "Error",
                  detail: "Something went wrong !!"
                });
              });
          }
        } else {
          this.messages.show({
            severity: "error",
            summary: "Error !!",
            detail: "Invalid Quantity !!"
          });
        }
      } else {
        // A Kit, B Kit
        let kitStock = 0;
        if (this.state.source === "A Kit") kitStock = this.state.a_kit;
        else if (this.state.source === "B Kit") kitStock = this.state.b_kit;

        if (
          this.state.qty <= kitStock &&
          this.state.qty > 0 &&
          this.state.patient !== null &&
          this.state.patient !== ""
        ) {
          const obj = {
            mno: this.state.mno,
            qty: this.state.qty,
            medicinename: this.state.name,
            source: "Transfer",
            stocktype: this.state.source,
            patient: this.state.patient,
            txnDate: this.state.txnDate
          };

          axios
            .post(
              (process.env.NODE_ENV !== "development"
                ? appConst.API_URL_PROD
                : appConst.API_URL_DEV) +

              "/medicine/transferKit",
              obj
            )
            .then(res => {
              this.ClearData();

              this.setState({
                toClass: "collapse",
                patientClass: "collapse"
              });

              this.growl.show({
                severity: "success",
                summary: "Success",
                detail: "Medicine Transferred !!!"
              });
              this.LoadNames();
            })
            .catch(error => {
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong !!"
              });
            });
        } else {
          this.messages.show({
            severity: "error",
            summary: "Error !!",
            detail: "Invalid Input !!"
          });
        }
      }
    } else {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Transfer Source !!"
      });
    }
  };

  ClearData() {
    this.setState({
      name: "",
      mainStock: 0,
      subStock: 0,
      a_kit: 0,
      b_kit: 0,
      qty: 0,
      source: "",
      transferTo: "",
      patient: ""
    });
  }

  onCancelClick = e => {
    this.ClearData();
    //this.props.onClick();
  };
}

export default Outbound;
